<div class="search__container">
    <input class="search__input" (change)="onChange($event.target.value)" (keyup)="onChange($event.target.value)"
        [disabled]="disabled" [value]="searchString" type="text" [placeholder]="placeholder">
</div>